import React from 'react';

const Header = ({ scrollY, menuOpen, setMenuOpen }) => {
  const headerHeight = Math.max(48, 72 - scrollY * 0.05);
  const logoSize = Math.max(0.75, 1.1 - scrollY * 0.001);

  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    setMenuOpen(false);
  };

  return (
    <>
      {/* Header */}
      <header style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: `${headerHeight}px`,
        backgroundColor: '#000',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
        transition: 'height 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)'
      }}>
        {/* Hamburger */}
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          style={{
            position: 'absolute',
            left: '24px',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: '8px',
            display: 'flex',
            flexDirection: 'column',
            gap: '4px',
            zIndex: 1001
          }}
          aria-label="Menu"
        >
          <span style={{
            display: 'block',
            width: '20px',
            height: '1px',
            backgroundColor: '#fff',
            transition: 'all 0.3s ease',
            transform: menuOpen ? 'rotate(45deg) translate(3px, 3px)' : 'none'
          }} />
          <span style={{
            display: 'block',
            width: '20px',
            height: '1px',
            backgroundColor: '#fff',
            transition: 'all 0.3s ease',
            opacity: menuOpen ? 0 : 1
          }} />
          <span style={{
            display: 'block',
            width: '20px',
            height: '1px',
            backgroundColor: '#fff',
            transition: 'all 0.3s ease',
            transform: menuOpen ? 'rotate(-45deg) translate(3px, -3px)' : 'none'
          }} />
        </button>

        {/* Logo */}
        <span style={{
          fontFamily: '"Alata", sans-serif',
          fontSize: `${logoSize}rem`,
          fontWeight: 400,
          letterSpacing: '0.4em',
          color: '#fff',
          transition: 'font-size 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
          textTransform: 'uppercase'
        }}>
          Talat
        </span>
      </header>

      {/* Menu Dropdown */}
      <nav style={{
        position: 'fixed',
        top: `${headerHeight}px`,
        left: 0,
        backgroundColor: '#000',
        padding: menuOpen ? '20px 24px' : '0 24px',
        zIndex: 999,
        overflow: 'hidden',
        maxHeight: menuOpen ? '200px' : '0',
        transition: 'all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
        opacity: menuOpen ? 1 : 0
      }}>
        {['Peinture', 'Musique', 'Parfum'].map((item) => (
          <button
            key={item}
            className="menu-item"
            onClick={() => scrollToSection(item.toLowerCase())}
            style={{
              display: 'block',
              fontFamily: '"Alata", sans-serif',
              fontSize: '0.75rem',
              color: '#fff',
              background: 'none',
              border: 'none',
              padding: '10px 0',
              letterSpacing: '0.15em',
              textTransform: 'uppercase',
              cursor: 'pointer',
              textAlign: 'left'
            }}
          >
            {item}
          </button>
        ))}
      </nav>
    </>
  );
};

export default Header;
